// v-float-dropdown — tira a lista do vue-multiselect de dentro do container
// que rola.
//
// A lista do multiselect é `position: absolute` dentro do próprio componente.
// Num painel com `overflow-y: auto` (o painel docado do Kanban, os forms do
// Studio) isso é cortado por definição: no card "Ações em cadeia" o select de
// tipo abria com 0 das 12 opções clicáveis. Aqui, enquanto o multiselect está
// aberto, a lista vira `position: fixed` medida a partir do gatilho — abaixo
// dele, ou acima quando não cabe — e volta ao normal ao fechar.
//
// Diretiva, e não prop: o vue-multiselect não tem teleport, e o sinal de
// "abriu" é a classe `multiselect--active` no root, que um MutationObserver
// enxerga sem precisar do instance do componente.
const ACTIVE_CLASS = 'multiselect--active';
const WRAPPER = '.multiselect__content-wrapper';
const MARGIN = 8;
const MAX_HEIGHT = 300;

const state = new WeakMap();

const place = el => {
  const wrapper = el.querySelector(WRAPPER);
  if (!wrapper) return;
  const rect = el.getBoundingClientRect();
  const below = window.innerHeight - rect.bottom - MARGIN;
  const above = rect.top - MARGIN;
  const wanted = Math.min(MAX_HEIGHT, wrapper.scrollHeight || MAX_HEIGHT);
  const openAbove = below < wanted && above > below;
  const height = Math.max(80, Math.min(wanted, openAbove ? above : below));

  Object.assign(wrapper.style, {
    position: 'fixed',
    left: `${rect.left}px`,
    width: `${rect.width}px`,
    maxHeight: `${height}px`,
    zIndex: '70',
    // O vue-multiselect posiciona "acima" com `bottom: 100%`; em fixed isso
    // não significa nada — zeramos e calculamos o topo nós mesmos.
    bottom: 'auto',
    top: openAbove ? `${rect.top - height}px` : `${rect.bottom}px`,
  });
};

const reset = el => {
  const wrapper = el.querySelector(WRAPPER);
  if (!wrapper) return;
  ['position', 'left', 'width', 'maxHeight', 'zIndex', 'bottom', 'top'].forEach(
    prop => {
      wrapper.style[prop] = '';
    }
  );
};

const attach = el => {
  const onMove = () => place(el);
  // Rolagem em QUALQUER ancestral (capture) e resize reposicionam; sem isso a
  // lista ficava presa no lugar enquanto o painel rolava por baixo.
  window.addEventListener('scroll', onMove, true);
  window.addEventListener('resize', onMove);
  state.get(el).detach = () => {
    window.removeEventListener('scroll', onMove, true);
    window.removeEventListener('resize', onMove);
  };
  place(el);
};

const detach = el => {
  const s = state.get(el);
  s?.detach?.();
  if (s) s.detach = null;
  reset(el);
};

export default {
  mounted(el) {
    const observer = new MutationObserver(() => {
      const active = el.classList.contains(ACTIVE_CLASS);
      const s = state.get(el);
      if (active && !s.detach) attach(el);
      if (!active && s.detach) detach(el);
    });
    state.set(el, { observer, detach: null });
    observer.observe(el, { attributes: true, attributeFilter: ['class'] });
  },
  unmounted(el) {
    detach(el);
    state.get(el)?.observer.disconnect();
    state.delete(el);
  },
};
